@import "../../sass/base/variables";
@import "../../sass/variables/forms";
@import "../../sass/functions";
@import '../../sass/components/form-field';

$dp-indicator: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' fill='#{$primary}'><path d='M26 4h-4V2h-2v2h-8V2h-2v2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 22H6V12h20Zm0-16H6V6h4v2h2V6h8v2h2V6h4Z'/></svg>") !default;

.som-dpi-input {
  appearance: none;
  background-position: right $input-padding-y center;
  background-repeat: no-repeat;
  background-size: 1.25rem;
  background-image: escape-svg($dp-indicator);

  &::placeholder {
    font-size: 0.9rem;
    color: $input-placeholder-color;
  }

  &::-ms-clear {
    display: none;
  }
}

.som-dpi-popover-content {
  padding: 0.625rem;
}
